
	import { Component, Vue, Prop } from 'vue-property-decorator';

	@Component({})
	export default class AppFooter extends Vue {
		@Prop({ required: true })
		protected link!: string;

		@Prop({ required: true, default: '' })
		protected text!: string;

		protected get copyrightsText(): string {
			return this.text.replace('&#169;', '©');
		}
	}
